import axios from 'axios';
import { Dispatch } from 'redux';
import {
  NpcInboundFreightAction,
  NpcInboundFreightActionTypes
} from '../../types/npcIboundFreight';
import { npcTypes } from '../../utils/constants';
import { errorHandler } from '../../utils/service';
import { setAlert } from './alert';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

const CancelToken = axios.CancelToken;
let cancelIFshipping: any = null;
let cancelIFbrands: any = null;
let cancelIFbrand: any = null;

export const getInboundFreightShipping =
  (data: any) => async (dispatch: Dispatch<NpcInboundFreightAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_SHIPPING_LOADING
      });

      if (cancelIFshipping) {
        cancelIFshipping();
        cancelIFshipping = null;
      }

      const config2 = {
        ...config,
        cancelToken: new CancelToken(function executor(c) {
          cancelIFshipping = c;
        })
      };

      const res = await axios.post(
        '/api/npcreports/inboundFreight/shipping',
        body,
        config2
      );
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_SHIPPING,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_SHIPPING,
        payload: {}
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType:
          NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_SHIPPING_LOADING
      });
    }
  };

export const getInboundFreightBrand =
  ({ from, to, brandId }: any) =>
  async (dispatch: Dispatch<NpcInboundFreightAction | any>) => {
    try {
      dispatch({
        type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRAND_LOADING
      });

      if (cancelIFbrand) {
        cancelIFbrand();
        cancelIFbrand = null;
      }

      const config2 = {
        cancelToken: new CancelToken(function executor(c) {
          cancelIFbrand = c;
        })
      };

      const res = await axios.get(
        `/api/npcreports/inboundFreight/brand?from=${from}&to=${to}&brandId=${brandId}`,
        config2
      );
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRAND,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRAND,
        payload: {}
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType:
          NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRAND_LOADING
      });
    }
  };

export const getInboundFreightBrands =
  (data: any) => async (dispatch: Dispatch<NpcInboundFreightAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRANDS_LOADING
      });

      if (cancelIFbrands) {
        cancelIFbrands();
        cancelIFbrands = null;
      }

      const config2 = {
        ...config,
        cancelToken: new CancelToken(function executor(c) {
          cancelIFbrands = c;
        })
      };

      const res = await axios.post(
        '/api/npcreports/inboundFreight/brands',
        body,
        config2
      );
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRANDS,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRANDS,
        payload: {}
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType:
          NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRANDS_LOADING
      });
    }
  };

export const getInboundFreightBrandItems =
  (data: any) => async (dispatch: Dispatch<NpcInboundFreightAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRAND_ITEMS_LOADING
      });

      const res = await axios.post(
        '/api/npcreports/inboundFreight/brandItems',
        body,
        config
      );
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRAND_ITEMS,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_BRAND_ITEMS,
        payload: {}
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType:
          NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_BRAND_ITEMS_LOADING
      });
    }
  };

export const getInboundFreightAnalytics =
  (data: any) => async (dispatch: Dispatch<NpcInboundFreightAction | any>) => {
    const body = JSON.stringify(data);
    try {
      dispatch({
        type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_ANALYTICS_LOADING
      });

      const res = await axios.post(
        '/api/npcreports/inboundFreight/analytics',
        body,
        config
      );
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_ANALYTICS,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_ANALYTICS,
        payload: []
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType:
          NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_ANALYTICS_LOADING
      });
    }
  };

export const getInboundFreightPO =
  ({ po }: any) =>
  async (dispatch: Dispatch<NpcInboundFreightAction | any>) => {
    try {
      dispatch({
        type: NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_PO_LOADING
      });

      const res = await axios.get(
        `/api/npcreports/inboundFreight/analytics?po=${po}`
      );
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_PO,
        payload: res.data
      });
    } catch (error) {
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_PO,
        payload: []
      });
      errorHandler({
        error,
        dispatch,
        setAlert,
        loadingType:
          NpcInboundFreightActionTypes.SET_NPC_INBOUND_FREIGHT_PO_LOADING
      });
    }
  };

export const getInboundFreightParams =
  () => async (dispatch: Dispatch<NpcInboundFreightAction | any>) => {
    const body = JSON.stringify({ types: [npcTypes.inboundFreight.value] });
    try {
      const res = await axios.post('/api/npc/params', body, config);
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_PARAMS,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_PARAMS,
        payload: {}
      });
    }
  };

export const getInboundFreightMinDate =
  () => async (dispatch: Dispatch<NpcInboundFreightAction | any>) => {
    const body = JSON.stringify({ types: [npcTypes.inboundFreight.value] });
    try {
      const res = await axios.post('/api/npc/mindate', body, config);
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_MINDATE,
        payload: res.data
      });
    } catch (error) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: NpcInboundFreightActionTypes.GET_NPC_INBOUND_FREIGHT_MINDATE,
        payload: ''
      });
    }
  };

export const clearInboundFreight =
  () => async (dispatch: Dispatch<NpcInboundFreightAction>) => {
    dispatch({
      type: NpcInboundFreightActionTypes.CLEAR_NPC_INBOUND_FREIGHT
    });
  };
